import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { InstallationFeaturesStore, RichDevice } from '@store';
import {
  ActivateDeactivateCommands,
  Feature,
  FeatureCommands,
  FeatureNames,
  FeaturePropertyKey,
  IsActiveProperty,
} from '@vi-iot/client/index';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-system-configurations',
  templateUrl: './system-configurations.component.html',
  styleUrls: ['./system-configurations.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SystemConfigurationsComponent implements OnInit {
  @Input() device: RichDevice;
  FEATURE_NAMES = FeatureNames;

  essOptimalSelfConsumption$: Observable<Feature<IsActiveProperty, ActivateDeactivateCommands>>;
  essBatterySleepMode$: Observable<Feature<IsActiveProperty, ActivateDeactivateCommands>>;
  essCyclicLoadCompressor$: Observable<Feature<IsActiveProperty, ActivateDeactivateCommands>>;
  essBackupReservedCapacity$: Observable<Feature<IsActiveProperty, ActivateDeactivateCommands>>;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  ngOnInit(): void {
    // Configuration
    this.essOptimalSelfConsumption$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.essOptimalSelfConsumption,
      this.device?.id,
      this.device?.gatewaySerial
    );

    this.essBatterySleepMode$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.essBatterySleepMode,
      this.device?.id,
      this.device?.gatewaySerial
    );

    this.essCyclicLoadCompressor$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.essCyclicLoadCompressor,
      this.device?.id,
      this.device?.gatewaySerial
    );

    this.essBackupReservedCapacity$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.essBackupReservedCapacity,
      this.device?.id,
      this.device?.gatewaySerial
    );
  }

  onToggleFeature(featureName: string, value: boolean): void {
    this.installationFeaturesStore.updateFeature(
      featureName,
      value,
      FeaturePropertyKey.active,
      null,
      value ? FeatureCommands.activate : FeatureCommands.deactivate,
      this.device?.gatewaySerial,
      this.device?.id
    );
  }
}
